<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Work Order Supply Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part Number - Name" id="input-" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" />
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Material Part Number" id="input-" size="sm" :model.sync="model.materialPartId"   :selected="model.materialPart != null ? model.materialPart.partNumber : ''" @input="getParts" />
				<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="part" optionsKey="id" label-cols-lg="12" label="Work Order Process Detail" id="input-" size="sm" :model.sync="model.workOrderProcessDetailId"   :selected="model.workOrderProcessDetail != null ? model.workOrderProcessDetail.part : ''" @input="getWorkOrderProcessDetails" />
				<app-input-combobox-autocomplete :options="billOfMaterialDetails" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Bill Of Material Detail" id="input-" size="sm" :model.sync="model.billOfMaterialDetailId"   :selected="model.billOfMaterialDetail != null ? model.billOfMaterialDetail.partNumber : ''" @input="getBillOfMaterialDetails" />
				<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Customer" id="input-" size="sm" :model.sync="model.customerId"   :selected="model.customer != null ? model.customer.code : ''" @input="getCustomers" />
				<app-input-textbox id="fieldset-qty-plan" label-cols-lg="12" label="Qty Plan" label-for="input-qty-plan" size="sm" :model.sync="model.qtyPlan"  />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-qty-consumption" label-cols-lg="12" label="Qty Consumption" label-for="input-qty-consumption" size="sm" :model.sync="model.qtyConsumption"  />
				<app-input-textbox id="fieldset-qty-transit" label-cols-lg="12" label="Qty Transit" label-for="input-qty-transit" size="sm" :model.sync="model.qtyTransit"  />
				<app-input-textbox id="fieldset-qty-stock" label-cols-lg="12" label="Qty Stock" label-for="input-qty-stock" size="sm" :model.sync="model.qtyStock"  />
				<app-input-textbox id="fieldset-qty-supply" label-cols-lg="12" label="Qty Supply" label-for="input-qty-supply" size="sm" :model.sync="model.qtySupply"  />
				<app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Uom" id="input-" size="sm" :model.sync="model.uomId"   :selected="model.uom != null ? model.uom.code : ''" @input="getUoms" />
				<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"  />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderSupplyDetail from '@/models/WorkOrderSupply/WorkOrderSupplyDetail';
import WorkOrderSupplyDetailFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyDetailFilter';

import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import AppLabel from '@/components/AppLabel';
import BillOfMaterialDetail from '@/models/BillOfMaterial/BillOfMaterialDetail';
import BillOfMaterialDetailFilter from '@/filters/BillOfMaterial/BillOfMaterialDetailFilter';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import Uom from '@/models/Uom/Uom';
import UomFilter from '@/filters/Uom/UomFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			parts : [],
			workOrderProcessDetails : [],
			billOfMaterialDetails : [],
			customers : [],
			uoms : [],
			isBusy: false,
		}
	},
	methods : {
		getWorkOrderSupplyDetail : async function(id) {
			this.isBusy = true;
			WorkOrderSupplyDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		getBillOfMaterialDetails : async function(input) {
			let filter = new BillOfMaterialDetailFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			BillOfMaterialDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfMaterialDetails = result.data
				}
			})
			.catch(error => {});
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		getUoms : async function(input) {
			let filter = new UomFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Uom.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.uoms = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getParts();
		//this.getParts();
		//this.getWorkOrderProcessDetails();
		//this.getBillOfMaterialDetails();
		//this.getCustomers();
		//this.getUoms();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getWorkOrderSupplyDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getParts();
				this.getWorkOrderProcessDetails();
				this.getBillOfMaterialDetails();
				this.getCustomers();
				this.getUoms();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getWorkOrderSupplyDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
